import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import {
  AD_ACCOUNT,
  CREATIVE,
  KEYWORD,
} from 'features/report/common/DomainText'
import {
  fetchReports,
  reset,
  setFormValues,
  setLoading,
  setPage,
  setReports,
} from 'features/report/reportAddSlice'
import { isNullOrUndefined, isPresent } from 'utils'
import useReportViewMode, {
  REPORT_ADD,
  REPORT_MODIFY,
} from 'features/report/hooks/useReportViewMode'
import { protocol } from 'features/report/reportApiUtils'
import api from 'api/axios/foka'
import { noop } from 'lodash'

const useTableUpdater = () => {
  const dispatch = useDispatch()

  const [lock, setLock] = useState(true)
  const mode = useReportViewMode()
  const [renderableDomain, setRenderableDomain] = useState(AD_ACCOUNT)
  const {
    formValues,
    formValues: {
      period,
      domain,
      domainStatuses,
      campaignId,
      adGroupId,
      metricsTypes,
      analysisItem,
      analysisPeriod,
    },
    page: currentPage,
  } = useSelector(state => state.report.reportAdd)

  useEffect(() => () => dispatch(reset()), [dispatch])

  useEffect(() => {
    if (mode.mode === REPORT_MODIFY) {
      setLock(true)
      dispatch(setLoading(true))
      const { domainPathVariable, reportIdPathVariable } = mode
      api.report
        .getDomainReportsById({
          domainPathVariable,
          reportIdPathVariable,
        })
        .then(({ data }) => {
          if (data) {
            const { metaData, result } = data
            if (
              (metaData.entity === CREATIVE || metaData.entity === KEYWORD) &&
              isNullOrUndefined(metaData.adGroupId)
            ) {
              metaData.adGroupId = ''
            }
            dispatch(setFormValues(metaData))
            dispatch(setReports(result))
            setRenderableDomain(metaData.entity)
          }
        })
        .catch(noop)
        .finally(() => dispatch(setLoading(false)))
    } else if (mode.mode === REPORT_ADD) {
      dispatch(fetchReports())
      setLock(false)
    }
  }, [mode, dispatch])

  useEffect(() => {
    if (lock) {
      setLock(false)
      return
    }

    if (mode.mode === REPORT_MODIFY || mode.mode === REPORT_ADD) {
      if (
        isPresent(domain) &&
        protocol[domain].every(
          key =>
            Object.prototype.hasOwnProperty.call(formValues, key) &&
            (key !== 'adGroupId'
              ? isPresent(formValues[key])
              : !isNullOrUndefined(formValues[key]))
        )
      ) {
        ;(async () => {
          await dispatch(fetchReports())
        })()
      }
      setRenderableDomain(domain)
    }
    // eslint-disable-next-line
  }, [
    currentPage,
    period,
    domain,
    domainStatuses,
    campaignId,
    adGroupId,
    metricsTypes,
    analysisItem,
    analysisPeriod,
    dispatch,
  ])

  const _setPage = page => dispatch(setPage(page))
  return [renderableDomain, _setPage]
}

export default useTableUpdater
